import {
  baseScreen,
} from 'hoc';
import React from 'react';
import {
  useHistory,
} from 'react-router';
import {
  VerificationMessage,
} from 'components';
import i18n from 'i18n-js';

const formConfirmation: React.FC = () => {
  const history = useHistory();
  return (
    <VerificationMessage
      message={i18n.t('ACCOUNTANT_CONFIRMATION_MESSAGE')}
      action={() => history.replace('/users/:id/accountants')}
    />
  );
};

export const AccountantFormConfirmation = baseScreen(formConfirmation, {
  allowedRoles: ['ADMIN', 'NONE'],
});
